var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createSlice } from '@reduxjs/toolkit';
export const COMPLETION_KEY = 'boushar.completion.records';
export const BONUS_ALL_COMPLETE = 100;
export const BONUS_COMPLETE_POSTPONED = 10;
const isRecord = (r) => r != null && typeof r.timestamp === 'string' && typeof r.durationMs === 'number';
export const loadCompletionState = () => {
    try {
        const stored = localStorage.getItem(COMPLETION_KEY);
        if (stored != undefined) {
            const parsed = JSON.parse(stored);
            return {
                allComplete: isRecord(parsed === null || parsed === void 0 ? void 0 : parsed.allComplete) ? parsed.allComplete : undefined,
                completePostponed: isRecord(parsed === null || parsed === void 0 ? void 0 : parsed.completePostponed) ? parsed.completePostponed : undefined,
                finished: (parsed === null || parsed === void 0 ? void 0 : parsed.finished) === true,
                bonusPoints: Number.isFinite(parsed === null || parsed === void 0 ? void 0 : parsed.bonusPoints) ? parsed.bonusPoints : 0
            };
        }
    }
    catch (error) {
        console.error('Failed to read completion records from localStorage:', error);
    }
    return { finished: false, bonusPoints: 0 };
};
const saveCompletionState = (state) => {
    try {
        const { pending: _pending } = state, persisted = __rest(state, ["pending"]);
        localStorage.setItem(COMPLETION_KEY, JSON.stringify(persisted));
    }
    catch (error) {
        console.error('Failed to save completion records to localStorage:', error);
    }
};
const completionSlice = createSlice({
    name: 'completion',
    initialState: loadCompletionState,
    reducers: {
        boardEvaluated: (state, action) => {
            const { finished, postponed, startedAt, now, silent } = action.payload;
            if (finished === state.finished) {
                return;
            }
            state.finished = finished;
            if (finished && silent) {
                saveCompletionState(state);
                return;
            }
            if (finished) {
                const start = startedAt != null ? Date.parse(startedAt) : NaN;
                const durationMs = Number.isNaN(start) ? 0 : Math.max(0, Date.parse(now) - start);
                const awarded = postponed === 0 ? BONUS_ALL_COMPLETE : BONUS_COMPLETE_POSTPONED;
                state.bonusPoints += awarded;
                state.pending = {
                    postponed,
                    durationMs,
                    awarded,
                    previousAllComplete: state.allComplete,
                    previousCompletePostponed: state.completePostponed
                };
                const record = { timestamp: now, durationMs };
                if (postponed === 0) {
                    state.allComplete = record;
                }
                else {
                    state.completePostponed = record;
                }
            }
            saveCompletionState(state);
        },
        dismissCompletion: (state) => {
            state.pending = undefined;
        }
    }
});
export const { boardEvaluated, dismissCompletion } = completionSlice.actions;
export default completionSlice;
